import { createPortal } from 'react-dom'
import { type DescribeData } from '../../../api/music'

/**
 * Модалка анализа трека (Mureka /song/describe). Запуск/состояние — хук
 * useDescribe (отдельный файл, чтобы Fast Refresh работал для компонента).
 *
 * Классы `track-cabinet__describe-*` — плоский BEM (одиночный класс, не вложенный
 * селектор), поэтому работают где угодно в DOM, не только внутри `.track-cabinet`.
 * Стили живут в `_track-cabinet.scss`.
 *
 * Рендер — порталом в body, как Sheet: инлайн-рендер внутри кабинета трека
 * ломал position:fixed оверлея (transform у панели делает её containing
 * block'ом) — затемнение прижималось к кабинету и торчало прямыми углами
 * за его скругления вместо полноэкранной вуали.
 */
export default function DescribeModal({ data, onClose }: { data: DescribeData; onClose: () => void }) {
	return createPortal(
		<div className="track-cabinet__describe-overlay" onClick={onClose}>
			<div className="track-cabinet__describe" onClick={(e) => e.stopPropagation()}>
				<button type="button" className="track-cabinet__describe-close" onClick={onClose} aria-label="Закрыть">×</button>
				<div className="track-cabinet__describe-title">Анализ трека</div>
				{data.genres.length > 0 && <div className="track-cabinet__describe-row"><span className="track-cabinet__describe-k">Жанры</span><div className="track-cabinet__describe-chips">{data.genres.map((g, i) => <span key={`g${i}`} className="track-cabinet__describe-chip">{g}</span>)}</div></div>}
				{data.tags.length > 0 && <div className="track-cabinet__describe-row"><span className="track-cabinet__describe-k">Настроение</span><div className="track-cabinet__describe-chips">{data.tags.map((t, i) => <span key={`t${i}`} className="track-cabinet__describe-chip">{t}</span>)}</div></div>}
				{data.instrument.length > 0 && <div className="track-cabinet__describe-row"><span className="track-cabinet__describe-k">Инструменты</span><div className="track-cabinet__describe-chips">{data.instrument.map((it, i) => <span key={`i${i}`} className="track-cabinet__describe-chip">{it}</span>)}</div></div>}
				{data.description && <p className="track-cabinet__describe-desc">{data.description}</p>}
			</div>
		</div>,
		document.body,
	)
}
